// ********************** BODY **************************** \\
const disableScroll = () => {
    document.body.classList.add('no-scroll');
}

const enableScroll = () => {
    document.body.classList.remove('no-scroll');
}

// ********************** CART **************************** \\
const showCart = () => {
    console.log('show cart');
    const cart = document.querySelector('.cart');
    cart.classList.add("show-cart");
    cart.setAttribute('aria-hidden', false);
    disableScroll ();
}

const hideCart = () => {
    console.log('hide cart');
    const cart = document.querySelector('.cart');
    cart.classList.remove('show-cart');
    cart.setAttribute('aria-hidden', true);
    enableScroll ();
}

document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;
  
    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      // Add the CSS class to the "body" tag
      showCart ();
    }
});

const runWhenInit = () => liquidAjaxCart.conf("quantityTagAllowZero", true);

// ********************** END CART **************************** \\


document.addEventListener("DOMContentLoaded", () => {
    const headerSection = document.getElementById('shopify-section-header');
    const headerUnderlay = document.querySelector('header .header-underlay');
    // ********************** HP HEADER **************************** \\
    const header = document.querySelector('.hp-header');
    const hpBtn = document.getElementById('hp-btn');
    const invisibleBtn = document.getElementById('invisible-btn');
    const hpHeaderMenuBtn = document.getElementById('desktop-nav-btn');
    const navContainer = document.querySelector('.hp-header .nav-container');
    const PAGEYOFFSET = 64;
    const isHomepage = document.body.classList.contains('index-template');

    if (window.liquidAjaxCart?.init) {
        // if Liquid Ajax Cart is already initialized
        runWhenInit();
      } else {
        // wait for Liquid Ajax Cart to be initialized
        document.addEventListener("liquid-ajax-cart:init", runWhenInit);
      }

    if (isHomepage) {
        const hpHeaderScrollAnimation = () => {
           
            if (window.scrollY > PAGEYOFFSET) {
                window.requestAnimationFrame(() => {
                    header.classList.add('scrolled')
                })
                
                headerUnderlay.classList.add('show-underlay');
            } else {
                 window.requestAnimationFrame(() => {
                    header.classList.remove('scrolled')
                })
                headerUnderlay.classList.remove('show-underlay');
                hpBtn.style.display = 'flex';
                navContainer.classList.add('hidden');  
                header.classList.remove('active-menu-header'); 
            }
            
        }
        hpHeaderScrollAnimation ();

        window.addEventListener('scroll', hpHeaderScrollAnimation, { passive: true });

        hpHeaderMenuBtn.addEventListener('click', () => {
            hpBtn.style.display = 'none';
            invisibleBtn.style.display = 'none';
            navContainer.classList.remove('hidden');  
            header.classList.add('active-menu-header'); 
        });
    }
    // ********************** END HP HEADER **************************** \\

    // ********************** HEADER **************************** \\
    // HEADER CART BTN
    document.querySelector("#cart-btn").addEventListener("click", showCart);

    const navBtns = document.querySelectorAll('.nav-btn');
    const subNavs = document.querySelectorAll('.subnav');
       

    navBtns.forEach(navBtn => {
        navBtn.addEventListener('mouseenter', () => {
            const dataHandle = navBtn.dataset.handle;
            const navToShow = document.getElementById(`subnav-${dataHandle}`);
            navBtns.forEach(n => {
                if (n.dataset.handle === dataHandle) {
                    n.classList.add('nav-btn-active');
                    n.setAttribute('aria-expanded', true);
                } else {
                    n.classList.remove('nav-btn-active');
                    n.setAttribute('aria-expanded', false);
                }
            })
                    
            console.log(navToShow, 'nav to show');
            if (navToShow) {
                subNavs.forEach(subNav => {
                    if (subNav.id === navToShow.id) {
                        subNav.classList.add('subnav-active');
                        subNav.setAttribute('aria-hidden', false);
                    } else {
                        subNav.classList.remove('subnav-active');
                    }
                })
            }
        });
    })
    headerSection.addEventListener('mouseleave', () => {
        subNavs.forEach(subNav => {
            subNav.classList.remove('subnav-active');
            navBtns.forEach(n => {    
                n.classList.remove('nav-btn-active');
                n.setAttribute('aria-expanded', false);
            })
        })
    })
        

    // ********************** END HEADER **************************** \\

    // ********************** MOBILE MENU **************************** \\
    const mobileMenuButton = document.getElementById('mobile-menu-btn');
    const mobileMenuCloseText = mobileMenuButton.querySelector('.close');
    const mobileMenuOpenText = mobileMenuButton.querySelector('.open');
    const mobileMenu = document.getElementById('mobile-menu');

    const hideMobileMenu = () => {
        mobileMenu.classList.remove('mobile-menu-active');
        mobileMenu.setAttribute('aria-hidden', true);
        mobileMenuButton.setAttribute('aria-expanded', false);
        mobileMenuCloseText.classList.add('hidden');
        mobileMenuOpenText.classList.remove('hidden');
        enableScroll ();
        headerUnderlay.classList.add('show-underlay');
    }

    const showMobileMenu = () => {
        mobileMenu.classList.add('mobile-menu-active');
        mobileMenu.setAttribute('aria-hidden', false);
        mobileMenuButton.setAttribute('aria-expanded', true);
        mobileMenuCloseText.classList.remove('hidden');
        mobileMenuOpenText.classList.add('hidden');
        disableScroll ();
        headerUnderlay.classList.remove('show-underlay');
    }

    const toggleMobileNav = () => {
        mobileMenu.classList.contains('mobile-menu-active') ? hideMobileMenu () : showMobileMenu ();
    }

    mobileMenuButton.addEventListener('click', toggleMobileNav)
    // ********************** END MOBILE MENU **************************** \\

    const onResize = () => {
        if (window.innerWidth > 768) {
            console.log('in here')
            hideMobileMenu ();
        }
    }

    window.addEventListener('resize', onResize, { passive: true });
})

